export const E_WALLET_REPORT_LIST = 'EWALLET/get_report';
export const GET_REPORTS = 'WALLET/get_reports';